import {
  Container,
  Box,
  Grid,
  IconButton,
  Link,
  Hidden,
  Button,
  Typography,
  Paper,
  FormControl,
  Select,
  MenuItem,
  TextField,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
// import useStyles from "./styles";
import { useFormContext, Controller } from "react-hook-form";

import { CardElement } from "@stripe/react-stripe-js";
import { useSharedBookReducer } from "../state";
import useUser from "../../../lib/useUser";

const ContactInfo = (props) => {
  const { user } = useUser();
  const [bookState, dispatch] = useSharedBookReducer();
  const { control, watch } = useFormContext();

  const handleChangeText = (path) => (e) => {
    dispatch({
      type: "MERGE",
      payload: {
        m: { [path]: e.target.value },
      },
    });
  };

  const skipContact = watch("skip_contact");

  return (
    <>
      {/* 

						<div class="field is-horizontal" v-if="showContactCollector">
							<div class="field-body">
								<div class="field is-expanded">
									<div class="control has-icons-left">
										<input class="input" type="text" placeholder="Your Name" name="name" v-model="m.contactname"
											v-validate="'required'">
										<span class="icon is-small is-left">
											<i class="fas fa-signature"></i>
										</span>
										<p class="help is-danger" v-if="errors.first('name')">
											\{{ errors.first('name') }}
										</p>
									</div>
								</div>
							</div>
						</div>

						<div class="field is-horizontal" v-if="showContactCollector">
							<div class="field-body">
								<div class="field is-expanded">
									<div class="control has-icons-left">
										<input class="input" type="text" placeholder="Your Phone Number (w/ Area Code)" name="phone"
											v-model="m.contactphone" v-validate="'required'">
										<span class="icon is-small is-left">
											<i class="fas fa-phone"></i>
										</span>
										<p class="help is-danger" v-if="errors.first('phone')">
											\{{ errors.first('phone') }}
										</p>
									</div>
								</div>
							</div>
						</div>
      </div>


						<div class="field is-horizontal" v-if="showContactCollector">
							<div class="field-body">
								<div class="field is-expanded">
									<div class="control has-icons-left">
										<input class="input" type="text" placeholder="Your Email Address (for confirmation)" name="email"
											v-model="m.contactemail" v-validate="'required|email'">
										<span class="icon is-small is-left">
											<i class="fas fa-envelope"></i>
										</span>
										<p class="help is-danger" v-if="errors.first('email')">
											\{{ errors.first('email') }}
										</p>
									</div>
								</div>
							</div>
						</div>

       */}
      <Typography variant="h5" gutterBottom>
        Contact Information
      </Typography>

      {user?.roles?.includes("admin") ? (
        <Controller
          name="skip_contact"
          control={control}
          defaultValue={false}
          render={({ field, fieldState }) => (
            <FormControlLabel
              control={<Checkbox {...field} checked={field.value} />}
              // sx={{
              //   border: fieldState.invalid ? "1px solid red" : undefined,
              //   marginRight: 0,
              //   paddingRight: "12px",
              // }}
              label={"Skip contact info required (and skip email!)"}
            />
          )}
          shouldUnregister
        />
      ) : null}

      <Controller
        name="name"
        control={control}
        defaultValue={process.env.NEXT_PUBLIC_DEFAULT_SIGNUP_NAME || ""}
        rules={{ required: !skipContact }}
        render={({ field, fieldState }) => (
          <TextField
            {...field}
            placeholder="Name"
            size="small"
            margin="dense"
            fullWidth
            error={fieldState.invalid ? true : false}
          />
        )}
        shouldUnregister
      />
      <br />
      <Controller
        name="phone"
        control={control}
        defaultValue={process.env.NEXT_PUBLIC_DEFAULT_SIGNUP_PHONE || ""}
        rules={{ required: !skipContact }}
        render={({ field, fieldState }) => (
          <TextField
            {...field}
            type="tel"
            placeholder="Phone Number"
            size="small"
            margin="dense"
            fullWidth
            error={fieldState.invalid ? true : false}
          />
        )}
        shouldUnregister
      />
      <br />
      <Controller
        name="email"
        control={control}
        defaultValue={process.env.NEXT_PUBLIC_DEFAULT_SIGNUP_EMAIL || ""}
        rules={{ required: !skipContact, pattern: /^\S+@\S+$/i }}
        render={({ field, fieldState }) => (
          <TextField
            {...field}
            type="email"
            placeholder="Email"
            size="small"
            margin="dense"
            fullWidth
            error={fieldState.invalid ? true : false}
          />
        )}
        shouldUnregister
      />
    </>
  );
};

export default ContactInfo;
